import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

const getAccountPagoMovil = async () => {
  return privateRequest.get(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}s`);
};

const postAccountPagoMovil = async data => {
  return privateRequest.post(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}`, data);
};

// [Disabled-edit-delete-pagoMovil]
const updateAccountPagoMovil = async data => {
  return privateRequest.patch(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}`, data);
};

const deleteAccountPagoMovil = async id => {
  return privateRequest.delete(`${ConfEnv.API_WALLET.URL_PAGO_MOVIL}/${id}`);
};

export {deleteAccountPagoMovil, getAccountPagoMovil, postAccountPagoMovil, updateAccountPagoMovil};
